// Import all of Bootstrap’s JS
import * as bootstrap from 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css';

// Import Google Maps API Loader
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";


import { getSession, listenToSession, sendStreamRequest, getSessionsWithin } from './data.js';

// Set the options for loading the API.
// Dev
// setOptions({ key: "AIzaSyAHbfjUHF7icd0-h_qnJCRz3942HTm4rTI" });

// Prod
setOptions({ key: "AIzaSyBEvcdQo887ZFMbS68VAEv37H239JtpkvE" });

let map;

const marketingEl = document.getElementById("marketing");
const appEl = document.getElementById("app");

let lastSessionCount = 0;
let lastMapBounds = null;

let sessionOverlays = [];

let latestDistanceMeters;
let latestAccuracyMeters;
let latestTrackingPointDate;

function formatTimeDelta(delta) {
  if (delta < 60) {
    return `${delta}s`
  } else if (delta < 3600) {
    return `${Math.floor(delta/60)}m ${delta%60}s`
  } else if (delta < 86400) {
    const secondsRemainder = delta % 3600
    const minutes = Math.floor(secondsRemainder / 60)
    const seconds = secondsRemainder % 60
    return `${Math.floor(delta/3600)}h ${minutes}m ${seconds}s`
  }
}

function updateDistanceLabel() {
  if (latestDistanceMeters === undefined || latestTrackingPointDate === undefined) {
    return;
  }
  const now = new Date();
  const delta = Math.floor((now - latestTrackingPointDate) / 1000);
  const timeAgo = formatTimeDelta(delta);
  const distText = `${latestDistanceMeters}±${latestAccuracyMeters} m, ${timeAgo} ago\n`;
  const element = document.getElementById("session-distance");
  if (element) {
    element.innerText = distText;
  }
}

setInterval(updateDistanceLabel, 1000);

function clearSessionOverlays() {
	sessionOverlays.forEach(overlay => {
		if (typeof overlay.setMap === 'function') {
			overlay.setMap(null);
		} else {
			overlay.map = null;
		}
	});
	sessionOverlays = [];
}

async function loadSessionsWithinBounds(minLat, maxLat, minLng, maxLng) {
	const sessions = await getSessionsWithin(minLat, maxLat, minLng, maxLng);
  console.log(sessions);
  lastSessionCount = sessions.length;
	sessions.forEach((session) => {
		renderSession(session, false);
	});

}

// Load the needed APIs.
async function loadGoogleMaps() {
    const { Map } = await importLibrary("maps");
	map = new Map(document.getElementById("map"), {
	    center: { lat: -34.397, lng: 150.644 },
	    zoom: 19,
		mapId: "HookedMapID",
		mapTypeControlOptions: {
			style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
   			position: google.maps.ControlPosition.TOP_CENTER
  		}
	  });

	var loadSessionsTimer;

	// Set listener to watch for coordinate changes in the map view
	// Disabled for public view
	// map.addListener("bounds_changed", () => {
  //   const newBounds = map.getBounds();
  //   const ne = newBounds.getNorthEast();
  //   const sw = newBounds.getSouthWest();
  //   const minLat = sw.lat();
  //   const maxLat = ne.lat();
  //   const minLng = sw.lng();
  //   const maxLng = ne.lng();

  //   clearTimeout(loadSessionsTimer);

  //   // Only load new sessions if the prev bounds didn't contain the new bound or if the previous 
  //   // result reached the limits of 100 sessions
  //   console.log(`Prev bounds ${lastMapBounds}`)
  //   console.log(`New bounds ${newBounds}`)
  //   var boundsContained = lastMapBounds != null && lastMapBounds.containsBounds(newBounds);
  //   console.log(`Prev bounds contains new bounds ${boundsContained}`)
  //   console.log(`Prev session count ${lastSessionCount}`)

  //   if (lastSessionCount == 100 || !boundsContained) {
  //   	lastMapBounds = newBounds;
	//     loadSessionsTimer = setTimeout((minLat, maxLat, minLng, maxLng) => {
	//     	loadSessionsWithinBounds(minLat, maxLat, minLng, maxLng);
	//     }, 500, minLat, maxLat, minLng, maxLng);	
  //   }
  // });
}

loadGoogleMaps();

async function renderMarketingPage() {
	marketingEl.hidden = false;
	appEl.hidden = true;
}

// 255s = 5min * 0.85, matching Android's MAX_STREAM_DURATION * 0.85 — re-requests before the
// host's boosted-streaming window from the previous request lapses.
const STREAM_REQUEST_INTERVAL_MS = 255 * 1000;

async function handleSession(sessionID) {
	const SESSION_LISTENER_TTL_MS = 60 * 60 * 1000; // 1 hour
	let isFirstRender = true;
	let subscriptionLevel;
	let streamRequestTimer;

	function startStreamRequestsIfNeeded() {
		if (subscriptionLevel !== "premium" || streamRequestTimer) {
			return;
		}
		sendStreamRequest(sessionID).catch(console.error);
		streamRequestTimer = setInterval(() => {
			if (document.visibilityState === "visible") {
				sendStreamRequest(sessionID).catch(console.error);
			}
		}, STREAM_REQUEST_INTERVAL_MS);
	}

	// Resume promptly instead of waiting out the rest of the interval when the tab
	// comes back into view, so the host's streaming boost doesn't lapse in the meantime.
	function handleVisibilityChange() {
		if (document.visibilityState === "visible" && streamRequestTimer) {
			sendStreamRequest(sessionID).catch(console.error);
		}
	}
	document.addEventListener("visibilitychange", handleVisibilityChange);

	const unsubscribe = listenToSession(sessionID, (session) => {
		renderSession(session, true, isFirstRender);
		isFirstRender = false;
		if (subscriptionLevel === undefined) {
			subscriptionLevel = session.subscriptionLevel;
			startStreamRequestsIfNeeded();
		}
	});

	setTimeout(() => {
		unsubscribe();
		clearInterval(streamRequestTimer);
		document.removeEventListener("visibilitychange", handleVisibilityChange);
		console.log("Session listener stopped after 1h TTL");
	}, SESSION_LISTENER_TTL_MS);
}

async function renderSession(session, drawTracks, shouldCenter = drawTracks) {
	clearSessionOverlays();

	const { AdvancedMarkerElement, PinElement } = await importLibrary("marker");
	const { Circle, Polyline } = await importLibrary("maps");

	marketingEl.hidden = true;
	appEl.hidden = false;

	const anchorPosition = session.anchorLocationV2
		? { lat: session.anchorLocationV2.latitude, lng: session.anchorLocationV2.longitude }
		: { lat: session.anchorLocation[1], lng: session.anchorLocation[0] };
	if (shouldCenter) {
		map.setCenter(anchorPosition);
	}

	// Set window URL
	console.log(window.location.href);
	window.history.pushState({}, 'Hooked', `${window.location.origin}/sessions/${session.id}`);

	// Start map rendering


	// Anchor Marker
	const anchorMarkerEl = document.createElement("div");
	anchorMarkerEl.className = "anchor-marker";

	const anchorMarker = new AdvancedMarkerElement({
		map: map,
		position: anchorPosition,
		title: "Anchor",
		content: anchorMarkerEl,
	});
	sessionOverlays.push(anchorMarker);

	const trackingPointsCount = session.trackingPoints.length;
  var boatPosition;
  var latestTrackingPoint;
  if (trackingPointsCount > 0) {

    latestTrackingPoint = session.trackingPoints[trackingPointsCount - 1];

    boatPosition = { lat: latestTrackingPoint.latitude, lng: latestTrackingPoint.longitude };
  }

	anchorMarker.addListener("click", ({ event, latLng }) => {
    console.log("Latitude and Longitude:", latLng);
    console.dir(session);
    // renderInfoPanel(session, boatPosition, latestTrackingPoint);
    renderSession(session, true);
  });

	// session.aisTargets.forEach((target, index) => {
	// 	console.log(target)
	// });

	const colors = [
		"#fea03b",
		"#fea940",
		"#feb445",
		"#febc49",
		"#fec64e",
		"#ffce53",
		"#ffd958",
		"#ffe15c",
		"#ffed61",
		"#fff566",
	];

	if (drawTracks) {
		// Anchor radius

		const anchorCircle = new Circle({
			strokeColor: "#FFFFFF",
			strokeOpacity: 0.0,
			strokeWeight: 2,
			fillColor: "#808080",
			fillOpacity: 0.3,
			map,
			center: anchorPosition,
			radius: session.anchorRadius,
		});

		anchorCircle.set('zIndex', 0);
		sessionOverlays.push(anchorCircle);

		if (boatPosition !== undefined) {
	      // Boat Marker
			const boatMarkerEl = document.createElement("div");
			boatMarkerEl.className = "boat-marker";

			const boatMarker = new AdvancedMarkerElement({
				map: map,
				position: boatPosition,
				title: "Boat",
				content: boatMarkerEl,
			});
			sessionOverlays.push(boatMarker);
		}

		renderInfoPanel(session, boatPosition, latestTrackingPoint);

		const opacity = 1.0;
		const strokeWeight = 4;

		if (trackingPointsCount > 1) {
	      // If less than 10 points, don't bother with the gradient
			if (trackingPointsCount < 10) {
				var trackCoords = [];

				for (var i in session.trackingPoints) {
					let trackingPoint = session.trackingPoints[i];
					trackCoords.push({lat: trackingPoint.latitude, lng: trackingPoint.longitude})
				}

				const track = new Polyline({
					path: trackCoords,
					geodesic: true,
					strokeColor: colors[5],
					strokeOpacity: opacity,
					strokeWeight: strokeWeight,
				});

				track.setMap(map);
				track.set('zIndex', 1);
				sessionOverlays.push(track);
			} else {
				const pointsPerBatch = Math.floor(trackingPointsCount / 10)
				const remainder = trackingPointsCount % 10;

				for (var b = 0; b < 10; ++b) {
					const batchIndexStart = b * pointsPerBatch
					const extendToNext = b < 9 || remainder > 0
					const batchIndexEnd = batchIndexStart + pointsPerBatch + (extendToNext ? 1 : 0)

					var trackCoords = []
					for (i = batchIndexStart; i < batchIndexEnd; ++i) {
						let trackingPoint = session.trackingPoints[i]
						trackCoords.push({lat: trackingPoint.latitude, lng: trackingPoint.longitude})
					}

					const track = new google.maps.Polyline({
						path: trackCoords,
						geodesic: true,
						strokeColor: colors[b],
						strokeOpacity: opacity,
						strokeWeight: strokeWeight,
					});

					track.setMap(map);
					track.set('zIndex', 1);
					sessionOverlays.push(track);
				}

	      		// Add remainder points to the last track
				var trackCoords = []
				for (i = 10 * pointsPerBatch; i < trackingPointsCount; ++i) {
					let trackingPoint = session.trackingPoints[i]
					trackCoords.push({lat: trackingPoint.latitude, lng: trackingPoint.longitude})
				}

				const track = new google.maps.Polyline({
					path: trackCoords,
					geodesic: true,
					strokeColor: colors[9],
					strokeOpacity: opacity,
					strokeWeight: strokeWeight,
				});

				track.setMap(map);
				track.set('zIndex', 1);
				sessionOverlays.push(track);
			}
		}
	}
  
}

async function renderInfoPanel(session, boatPosition, latestTrackingPoint) {
	const { spherical } = await importLibrary("geometry");

	const anchorPosition = session.anchorLocationV2
		? { lat: session.anchorLocationV2.latitude, lng: session.anchorLocationV2.longitude }
		: { lat: session.anchorLocation[1], lng: session.anchorLocation[0] };

	// Start info panel rendering
	const infoFields = [
		"name",
		"startDate",
		"anchorLocation",
		"anchorRadius",
		"latestBatteryLevel",
		"trackingPointSourceName",
		"latestWindSpeed",
		"latestDepth",
		"maxWindSpeed",
	];
  

	infoFields.forEach((fieldName, index) => {
		const elementId = `session-${fieldName}`;
		const element = document.getElementById(elementId);
		var value = session[fieldName];

		if (fieldName == "startDate") {
			value = value.toDate();
		}

		if (fieldName == "anchorLocation") {
			const anchorLat = Math.round(value[1] * 10000) / 10000;
    	const anchorLatSuffix = anchorLat > 0 ? "N" : "S"
    	const anchorLng = Math.round(value[0] * 10000) / 10000;
    	const anchorLngSuffix = anchorLng > 0 ? "E" : "W"
    	value = `${anchorLat}${anchorLatSuffix}, ${anchorLng}${anchorLngSuffix}`;
		}

		if (fieldName == "anchorRadius") {
			value = `${Math.round(value * 10) / 10}m`
		}

		if (fieldName == "latestBatteryLevel") {
			const iconElement = document.getElementById("session-latestBatteryLevel-icon");
			var icon = "fw-bold bi-battery";
			if (value < 0.2) {
				icon = "fw-bold bi-battery-low";
			} else if (value < 0.7) {
				icon = "fw-bold bi-battery-half";
			} else {
				icon = "fw-bold bi-battery-full";
			}
			var value = `${Math.round(100 * value)}%`;

    	if (session.batteryCharging) {
      	value += " (charging)";
      	icon = "fw-bold bi-battery-charging";
    	}
    	iconElement.className = icon;
		}

		if (fieldName == "latestDepth" || fieldName == "latestWindSpeed" || fieldName == "maxWindSpeed") {
			value = Math.round(value * 100) / 100;
		}

		element.innerText = value;
	});

	// Special sauce for the latest distance
	if (boatPosition !== undefined && latestTrackingPoint !== undefined) {
    latestDistanceMeters = Math.round(spherical.computeDistanceBetween(boatPosition, anchorPosition) * 10) / 10;
    latestAccuracyMeters = Math.round(latestTrackingPoint.accuracy);
    latestTrackingPointDate = latestTrackingPoint.date.toDate();
    updateDistanceLabel();
  } else {
    latestDistanceMeters = undefined;
    latestTrackingPointDate = undefined;
  }

  // Show the info panel
  const infoPanel = document.getElementById("info-panel")
  const infoPanelDetails = document.getElementById("info-panel-details")
  const hidePanelButton = document.getElementById("hide-info-btn")
  const showPanelButton = document.getElementById("show-info-btn")
  
  hidePanelButton.onclick = function() {
  	infoPanelDetails.hidden = true;
  	hidePanelButton.hidden = true;
  	showPanelButton.hidden = false;
  };

  showPanelButton.onclick = function() {
  	infoPanelDetails.hidden = false;
  	hidePanelButton.hidden = false;
  	showPanelButton.hidden = true;
  };

  infoPanel.hidden = false;
}

// Check if we are trying to access a session

const parseSessionID = /\/sessions\/([A-Fa-f0-9]{8}-(?:[A-Fa-f0-9]{4}-){3}[A-Fa-f0-9]{12})/;
const pathname = window.location.pathname;

const sessionIDMatch = pathname.match(parseSessionID)

if (sessionIDMatch != null) {
	console.log("Got session ID")
	const sessionID = sessionIDMatch[1]
	console.log(sessionID)
	handleSession(sessionID)
} else {
  	console.log("Not viewing a session");
  	renderMarketingPage();
}